import {
  StyleSheet,
} from 'react-native';

export default StyleSheet.create({
  confetti: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  bodyRowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 11,
    marginHorizontal: 8,
  },

  rowText: {
    fontSize: 16,
    color: '#2E323A',
    fontStyle: 'normal',
    fontFamily: 'Helvetica Neue',
    fontWeight: 'normal',
  },

  totalText: {
    fontSize: 16,
    color: '#2E323A',
    fontStyle: 'normal',
    fontFamily: 'Helvetica Neue',
    fontWeight: 'bold',
  },

  divider: {
    marginHorizontal: 8,
    marginBottom: 11,
    height: 1,
    backgroundColor: '#717B8F',
    opacity: 0.5,
  },

  disclaimerText: {
    fontSize: 14,
    color: '#717B8F',
    fontStyle: 'normal',
    fontFamily: 'Helvetica Neue',
    fontWeight: 'normal',
    opacity: 0.5,
    marginHorizontal: 8,
  },

  modalOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const customModalStyles = StyleSheet.create({
  mainContainer: {
    width: 315,
  },

  title: {
    marginTop: 16,
  },

  primaryButton: {
    backgroundColor: '#4990E2',
    fontSize: 15,
  },
});

export const ticketzStyles = StyleSheet.create({
  ticketLabelContainer:{
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export const zStyles = StyleSheet.create({
  pointsLabelContainer:{
    flexDirection: 'row',
    alignItems: 'center',
  }
});